import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import MomentUtils from '@date-io/moment';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import { withStyles } from '@material-ui/core/styles';
import { createBaseStyles } from './styles';

const styles = theme => ({
  root: {
    visibility: props => (props.hidden ? 'hidden' : 'inherit'),
    ...createBaseStyles(theme),
  },
});

function DateField({
  className,
  classes,
  onChange,
  variant,
  value,
  ...rest
}) {
  const adjustedValue = (dateMoment) => (dateMoment?.isValid() ? dateMoment.toISOString() : '');

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <KeyboardDatePicker
        autoOk
        className={classNames(classes.root, className)}
        classes={{
          root: classes.root,
        }}
        variant="inline"
        disableToolbar
        format="MM/DD/YYYY"
        inputVariant={variant}
        onChange={(dateMoment) => {
          return onChange(adjustedValue(dateMoment));
        }}
        KeyboardButtonProps={{
          'aria-label': 'change date',
          test: 'change-date-button',
        }}
        value={value || null} // Datepicker expects null when empty. Empty string or undefined will both result in an error in rifm
        maxDate={new Date('3000-01-01')}
        {...rest}
      />
    </MuiPickersUtilsProvider>
  );
}

DateField.defaultProps = {
  className: '',
  variant: 'standard',
  value: '',
};

DateField.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  value: PropTypes.string,
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard']),
};

export default withStyles(styles, { name: 'DateField' })(DateField);
